
class PatientsCallApi {

    //Trae el Consultorio de la Admision
    async getSpaceAdmision(admision) {
        let dataPatient = null;
        let paciente = admision.fullname;
        let dataSendPatient = {
            id_admision: admision.id_admision,
            id_cita: admision.id_cita
        }
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}admision/consultar-espacio`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSendPatient)
        }).then(response => {
            return response.json();
        }).then(data => {
            if (data.espacio != null && paciente != null) {
                let pacienteLlamado = {
                    id_admision : admision.id_admision,
                    nombre: paciente.toString(),
                    espacio: data.espacio.toString()
                }
                dataPatient = pacienteLlamado;
            }
            else {
                alert("No fue posible llamar al paciente");
            }
        }).catch(error => {
            console.log(error);
            alert("Ha ocurrido un error llamando al paciente");
            return null;
        });
        return dataPatient;
    }
}

export default new PatientsCallApi();
